import Vue from 'vue'
import App from './App.vue'
import {
	Pagination,
	Dialog,
	Autocomplete,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	Menu,
	Submenu,
	MenuItem,
	MenuItemGroup,
	Input,
	InputNumber,
	Radio,
	RadioGroup,
	RadioButton,
	Checkbox,
	CheckboxButton,
	CheckboxGroup,
	Switch,
	Select,
	Option,
	OptionGroup,
	Button,
	ButtonGroup,
	Table,
	TableColumn,
	DatePicker,
	TimeSelect,
	TimePicker,
	Popover,
	Tooltip,
	Breadcrumb,
	BreadcrumbItem,
	Form,
	FormItem,
	Tabs,
	TabPane,
	Tag,
	Tree,
	Alert,
	Slider,
	Icon,
	Row,
	Col,
	Upload,
	Progress,
	Spinner,
	Badge,
	Card,
	Rate,
	Steps,
	Step,
	Carousel,
	CarouselItem,
	Collapse,
	CollapseItem,
	Cascader,
	ColorPicker,
	Transfer,
	Container,
	Header,
	Aside,
	Main,
	Footer,
	Timeline,
	TimelineItem,
	Link,
	Divider,
	Image,
	Calendar,
	Backtop,
	PageHeader,
	CascaderPanel,
	Loading,
	MessageBox,
	Message,
	Notification, Result
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import router from '../router'
import store from './store'
import http from 'axios'
// import '../api/mock.js'
import {Base64} from 'js-base64';
import dateUtils from '../utils/dateUtils.js'
import VueContextMenu from 'vue-contextmenu'
import VueClipboard from 'vue-clipboard2';
import VueClipboards from 'vue-clipboards';

import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/darcula.css' ;  //这个是你设置了什么主题，就要对应的在main.js中引入主题的css

// 富文本组件
import Editor from "@/components/Editor";
import {getStore, setStore} from '../utils/store';
import el from "element-ui/src/locale/lang/el";


// 全局组件挂载
Vue.component('Editor', Editor)

Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Spinner);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);
Vue.use(ColorPicker);
Vue.use(Transfer);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Link);
Vue.use(Divider);
Vue.use(Image);
Vue.use(Calendar);
Vue.use(Backtop);
Vue.use(PageHeader);
Vue.use(CascaderPanel);
Vue.use(Result);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;

Vue.use(Loading);
Vue.use(VueContextMenu);
Vue.use(VueClipboard);
Vue.use(VueClipboards);

Vue.use(codemirror);

Vue.config.productionTip = false
Vue.prototype.$http = http;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;

router.beforeEach((to, from, next) => {  //导航守卫
	const token = localStorage.getItem("token")
	const expdate = localStorage.getItem("expdate")
	const lastdate_ = localStorage.getItem("lastdate")
	const lastDate = new Date(lastdate_)
	const curDate = new Date()
	let exp = false
	let span = dateUtils.DateDiff(curDate,lastDate)
	if(expdate && span>expdate){
		exp=true
	}
	let userInfo=getStore({name: 'userInfo'});
	if((!token || exp ) && to.name != 'login'){ //token为空，exp==true过期，目标页不是login
		next({name: 'login'})
	}
	else if(token && !exp && to.name === 'login'){  //token不为空，exp==false未过期，目标页是login
            if(userInfo.roleId==3){
				next({name: 'iothome'})
			}else{
				next({name: 'Main'})
			}
	}
	else{
	     next()
	}
})

new Vue({
  render: h => h(App),
  store,
  router,
  created(){
  	store.commit('addMenu', router)  //动态添加路由
  }
}).$mount('#app')
